module.exports = __webpack_public_path__ + "img/paulzen.6b7afec7.jpg";